<template>
  <div>
    <div class="web-only landing">
      <!-- <div class="web-only" style="padding-top: 17.5vh; padding-bottom: 12vh; padding-left: 8%; padding-right: 8%; width: 100%;">
        <div class="center">
          <h1 style="font-weight: 900; margin-bottom: 18px;">Stop wasting time</h1>
          <h4 style="font-weight: 300; margin-bottom: 35px; max-width: 700px; margin-left: auto; margin-right: auto;">Run your agency smarter with the all-in-one software solution customized just for you. Your clients and candidates will love it.</h4>
          <iframe style="margin-bottom: 20px;" width="660" height="325" src="https://www.youtube.com/embed/cOBFDBlW-L4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div> -->

      <div
        class="row web-only"
        style="
          color: white;
          padding-top: 150px;
          padding-bottom: 150px;
          padding-left: 7%;
          padding-right: 7%;
          width: 100%;
        "
      >
        <div class="col-lg-6 col-md-7 my-auto">
          <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
          <h1 style="font-weight: 900; margin-bottom: 12px">
            Stop wasting time
          </h1>
          <!-- <div class="web-only">
            <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
          </div> -->
          <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
          <p style="
              font-size: 1.75rem;
              line-height: 1.35;
              margin-top: 25px;
              margin-bottom: 2px;
              max-width: 550px;
            ">
            Run your agency smarter with the all-in-one software solution
            customized just for you. Your clients and candidates will love it.
          </p>
          <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
          <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
        </div>
        <div
          class="col-lg-6 col-md-5 my-auto web-only"
          style="border-radius: 5%"
        >
          <!-- <img src="../assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg" width="100%" height="" alt="digital recruitment platform"> -->
          <iframe
            width="600"
            height="335"
            src="https://www.youtube.com/embed/8_JE_wDjJoc"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="border-radius: 0.5%"
          ></iframe>
        </div>
      </div>
    </div>

    <div class="mobile-only mobile-landing">
      <div
        class=""
        style="
          color: white;
          padding-top: 17.5vh;
          padding-bottom: 60px;
          padding-left: 2%;
          padding-right: 2%;
          width: 100%;
        "
      >
        <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
        <h3
          style="font-weight: 900; margin-bottom: 8px"
          class="center"
        >
          Stop wasting time
        </h3>
        <div class="">
          <h4
            style="margin-bottom: 4px; line-height: 1.4"
            class="center"
          >
            Run your agency smarter with a software solution designed just for
            you. Your clients and candidates will love it.
          </h4>
          <!-- <h3>solo and small staffing operations.</h3> -->
        </div>
        <div
          class="center"
          style="padding-top: 20px; padding-bottom: 20px"
        >
          <!-- <img src="../assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg" width="100%" height="" alt="digital recruitment platform"> -->
          <iframe
            width="100%"
            height="180px"
            src="https://www.youtube.com/embed/8_JE_wDjJoc"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <!-- <p style="margin-bottom: 2px;" class="center">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
        <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
        <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
      </div>
    </div>

    <div
      class="web-only"
      style="padding-left: 7%; padding-right: 7%"
    >
      <div
        class="mb-5 big-carousel"
        style="margin-top: 75px"
      >
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="3"
        />
      </div>
      <div
        class="mb-5 medium-carousel"
        style="margin-top: 75px"
      >
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="2"
        />
      </div>
    </div>
    <!-- <div class="web-only" style="padding-left: 7%; padding-right: 7%">
      <em style="margin-top: 90px" class="center mb-4"
        >Trusted by an agency near you</em
      >
      <div
        class="row"
        style="max-width: 940px; margin-left: auto; margin-right: auto"
      >
        <div
          class="col customer-logo-container"
          v-for="(agency, index) of listAgencies"
          :key="'agency-' + index"
        >
          <a :href="agency.url" target="_blank">
            <img
              :src="require(`../assets/img/home/customer_logos/${agency.logo}`)"
              width=""
              height=""
              :alt="agency.alt"
              class="customer-logo"
            />
          </a>
        </div>
      </div>
    </div> -->

    <!-- <div class="web-only">
      <em style="margin-top: 90px" class="center mb-4"
        >Proud member and sponsor of</em
      >
      <div class="row" style="max-width: 450px; margin-left: auto; margin-right: auto">
        <div class="col association-logo-container">
          <a href="https://nanny.org/" target="_blank">
            <img src="../assets/img/associations/INA Member.png" alt="" class="association-logo">
          </a>
        </div>
        <div class="col association-logo-container">
          <a href="https://theapna.org/" target="_blank">
            <img src="../assets/img/associations/APNA.png" alt="" class="association-logo">
          </a>
        </div>
      </div>
    </div> -->

    <div
      class="mobile-only"
      style="
        padding-top: 30px;
        padding-bottom: 50px;
        padding-left: 2%;
        padding-right: 2%;
      "
    >
      <div class="small-carousel">
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="1"
        />
      </div>
      <div class="tiny-carousel">
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="1"
          :navigationEnabled="false"
        />
      </div>
      <!-- <div class="">
        <p
          class="center"
          style="font-size: 1rem; padding-top: 20px; padding-bottom: 10px"
        >
          <em>Trusted by an agency near you</em>
        </p>
        <transition name="logo" mode="out-in">
          <template v-for="(agency, index) of listAgencies">
            <div
              :key="'agency-mobile-' + index"
              class="customer-logo-container"
              v-if="logoCount === index + 1"
            >
              <a :href="agency.url" target="_blank">
                <img
                  :src="
                    require(`../assets/img/home/customer_logos/${agency.logo}`)
                  "
                  width=""
                  height=""
                  :alt="agency.alt"
                  class="customer-logo"
                />
              </a>
            </div>
          </template>
        </transition>
      </div> -->
      <!-- </div> -->
    </div>

    <div
      class="web-only center"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 120px;
        margin-bottom: 130px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5 style="color: white; margin-bottom: 33px">
        <em>Discover how Enginehire can work for your agency</em>
      </h5>
      <!-- <button
        class="mylisting-button light-button"
        onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
      >
        Book a Demo
      </button> -->
      <div class="mt-3">
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button light-button"
        >Book a Demo</router-link>
      </div>
      <!-- <button class="mylisting-button dark-button">Book a Demo</button> -->
    </div>

    <div
      class="mobile-only center"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 20px;
        margin-bottom: 100px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5
        style="color: white; margin-bottom: 33px"
        class="px-4"
      >
        <em>Discover how Enginehire can work for your agency</em>
      </h5>
      <!-- <button
        class="mylisting-button light-button"
        onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
      >
        Book a Demo
      </button> -->
      <div class="mt-3">
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button light-button"
        >Book a Demo</router-link>
      </div>
      <!-- <button class="mylisting-button dark-button">Book a Demo</button> -->
    </div>

    <div
      class="web-only"
      style="padding-left: 7%; padding-right: 7%"
    >
      <div
        class="center mb-5"
        style="margin-top: 70px"
      >
        <h3 style="font-weight: 600; margin-bottom: 10px">
          Spend less time. Make more money.
        </h3>
        <h5 class="mb-4">
          Stop doing grunt work. Agency owners like you using Enginehire...
        </h5>
        <img
          style="max-width: 80%"
          src="../assets/img/home/landing/key-benefits-text.svg"
          alt=""
        />
      </div>
    </div>

    <div
      class="mobile-only"
      style="padding-left: 7%; padding-right: 7%"
    >
      <div
        class="center mb-5"
        style="margin-top: 40px"
      >
        <h3 style="font-weight: 600; margin-bottom: 5px">Spend less time.</h3>
        <h3 style="font-weight: 600; margin-bottom: 10px">Make more money.</h3>
        <h5 class="mb-4">
          Stop doing grunt work. Agency owners like you using Enginehire...
        </h5>
        <img
          style="max-width: 100%"
          src="../assets/img/home/landing/key-benefits-mobile-text.svg"
          alt=""
        />
      </div>
    </div>

    <div
      class="web-only center"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 120px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5 style="color: white; margin-bottom: 33px"><em>Features & Functionality</em></h5>
      <!-- <a
        href="https://youtu.be/cOBFDBlW-L4"
        target="_blank"
        style="color: white"
        ><button class="mylisting-button light-button">
          Watch the 3 Minute Demo
        </button></a
      > -->
      <div class="mt-3">
        <router-link
          :to="{ name: 'Demo Video' }"
          class="mylisting-button light-button"
        >Watch the 3 Minute Demo</router-link>
      </div>
    </div>

    <div
      class="mobile-only center"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 100px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5 style="color: white; margin-bottom: 33px"><em>Features & Functionality</em></h5>
      <!-- <a
        href="https://youtu.be/cOBFDBlW-L4"
        target="_blank"
        style="color: white"
        ><button class="mylisting-button light-button">
          Watch the 3 Minute Demo
        </button></a
      > -->
      <div class="mt-3">
        <router-link
          :to="{ name: 'Demo Video' }"
          class="mylisting-button light-button"
        >Watch the 3 Minute Demo</router-link>
      </div>
    </div>

    <div style="padding-left: 7%; padding-right: 7%">
      <div class="features-summary-section">
        <div
          class="card feature-container"
          v-for="(feature, index) of listFeatures"
          :key="'feature-' + index"
        >
          <img
            class="feature-img"
            :src="require(`../assets/img/home/icons/${feature.icon}`)"
            alt="Card image cap"
          />
          <div class="card-body">
            <h4 class="card-title">{{ feature.title }}</h4>
            <p class="card-text">
              {{ feature.text }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="center pt-5 pb-5" style="margin-top: 60px; margin-bottom: 120px;">
        <h4 style="color: var(--coredarkcolor);">Want to see these features and functionality in action?</h4>
        <a href="https://youtu.be/cOBFDBlW-L4" target="_blank" style="color: white;;"><button class="mylisting-button dark-button">Watch the 2 Minute Demo</button></a>
      </div> -->

    <!-- <div
      class="web-only"
      style="
        background-color: var(--coredarkcolor);
        padding-top: 45px;
        padding-bottom: 45px;
      "
    >
      <p class="center" style="color: white">
        <strong
          >Enginehire Inc. | 1855 755 4473 |
          <a
            href=""
            onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
            >Book a Demo</a
          >
          | info@enginehire.io | Hiring re-engineered.</strong
        >
      </p>
      <img
        src="../assets/img/logo/enginehire logo thin white 1.3 letterpaths.svg"
        width=""
        height="55"
        alt="Enginehire"
        style=""
        class="center mt-4"
      />
    </div> -->
    <!-- <div class="landing">

      <div class="row web-only" style="padding-top: 25vh; padding-bottom: 21vh; padding-left: 10%; padding-right: 10%; width: 100%;">
        <div class="col-lg-6 col-md-7 my-auto">
          <h1 style="font-weight: 900; margin-bottom: 8px;">Be a Modern Recruiter</h1>
          <div class="web-only">
            <h3 style="margin-bottom: 4px;">With the website solution built for</h3>
            <h3>solo and small staffing operations.</h3>
          </div>
          <p style="font-size: 1.2rem; margin-top: 30px; margin-bottom: 2px;">Transform your business with a custom recruitment platform.</p>
          <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p>
          <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p>
        </div>
        <div class="col-lg-6 col-md-5 my-auto web-only" style="">
          <img src="../assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg" width="100%" height="" alt="digital recruitment platform">
        </div>
      </div>

      <div class="mobile-only" style="padding-top: 16vh; padding-bottom: 14vh; padding-left: 10%; padding-right: 10%; width: 100%; text-align: center;">
        <h1 style="font-weight: 900; margin-bottom: 15px;">Be a Modern Recruiter</h1>
        <h3 class="mobile-only" style="margin-bottom: 4px;">With the website solution built for solo and small staffing operations.</h3>
        <img src="../assets/img/home/landing/AdobeStock_285202108_monitor2_iconcolors3.svg" class="mobile-only" style="margin-top: 30px; display: block; text-align: center; margin-left: auto; margin-right: auto;" width="100%" height="" alt="digital recruitment platform">
        <p style="font-size: 1.2rem; margin-top: 30px; margin-bottom: 2px; text-align: center;">Transform your business with a custom recruitment platform. Offer candidates and clients a seamless experience and establish your brand as the go to for your niche.</p>
      </div>
    </div> -->

    <!-- <div style="padding-top: 15vh; padding-bottom: 15vh; padding-left: 10%; padding-right: 10%; background-color: #eaf4fe;">
      <h3 style="text-align: center;" class="mb-3">Meet recruiters like you running their businesses on Enginehire</h3>
      <h5 style="text-align: center; font-weight: 300;">Visit their platforms and imagine what yours might look like, fully customized and optimized!</h5>
      <div class="card-deck mb-1">
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Hayley2.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Hayley</h4>
            <p class="card-text">CEO of ThriveHire - Recruitment for the global health community</p>
            <h5 class="center pb-2" style="font-weight: 300; max-width: 800px; font-style: italic">It’s been a great opportunity working with EngineHire to build our platform. Their team have been extremely responsive to any of our requests. Their professionalism is top-notch, and they are always open to customizing our platform to best fit the needs of our organization. We highly recommend their work!</h5>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.thrivehire.co" target="_blank">Visit My Platform</a>
            </div>

          </div>
        </div>
      </div>
      <div class="card-deck mb-5">
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Steven2.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Steven</h4>
            <p class="card-text">Co-Owner of PharmaShyft - Recruitment platform for pharmacists</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.pharmashyft.com" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Daniel_heart.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Daniel</h4>
            <p class="card-text">CEO of Dame Una Mano - Recruiting in-home caregivers for the elderly</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.serviciosdum.com" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Alex.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Alex</h4>
            <p class="card-text">CEO of LocalStudent - Helping students find work in their community</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.localstudent.ca" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
      </div>

      <div class="center" style="margin-top: 12vh;">
        <h2>Ready to begin your digital transformation?</h2>
        <h4 style="font-weight: 300;" class="web-only mt-3">Get in touch: info@enginehire.io | 1855 775 4473</h4>
        <h4 style="font-weight: 300;" class="mobile-only mt-3">Get in touch:</h4>
        <h5 style="margin-top: 10px; font-weight: 300;" class="mobile-only">1855 755 4473 | info@enginehire.io</h5>
        <div class="" style="margin-top: 33px;">
          <router-link :to="{ name: 'Contact' }" class="mylisting-button light-button shadow">Book a Demo</router-link>
        </div>
      </div>
    </div> -->

    <!-- <div
      class="mobile-only"
      style="
        background-color: var(--coredarkcolor);
        padding-top: 35px;
        padding-bottom: 35px;
      "
    >
      <p
        class="center"
        style="color: white; font-size: 0.9rem; padding-top: 1.25vh"
      >
        Enginehire Inc. | 1855 755 4473 |
        <a
          href=""
          onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
          >Book a Demo</a
        >
        | info@enginehire.io | Hiring re-engineered.
      </p>
      <img
        src="../assets/img/logo/enginehire logo thin white 1.3 letterpaths.svg"
        width=""
        height="55"
        alt="Enginehire"
        style=""
        class="center mt-4"
      />
    </div> -->
  </div>
</template>

<script>
import CarouselComponent from "./CarouselComponent";

export default {
  components: {
    CarouselComponent,
  },
  // https://stackoverflow.com/questions/49849376/vue-js-triggering-a-method-function-every-x-seconds
  mounted: function () {
    window.setInterval(() => {
      this.incrementLogoCount();
    }, 3000);
  },
  data() {
    return {
      logoCount: 1,
      listTestimonial: [
        {
          text: "<strong>We have used so many platforms.</strong> From iCims to Bullhorn, to trying to create ones ourselves with Zoho, Asana, Monday.com, Trello, and Airtable. <strong>They just did not work for our industry.</strong> Enginhire has created a system that is simple to use with lots of amazing features. I am so glad we found them.",
          img: {
            src: "Ruka.png",
            alt: "Ruka Curate",
          },
          personInfo: "Ruka C",
          link: {
            text: "",
            url: "https://www.tinytreasuresnyc.com/",
          },
        },
        {
          text: "As an agency our previous experiences with other software has been less than ideal, but Enginehire has been an absolute breath of fresh air. They are <strong>loyal, reliable, and extremely quick to respond</strong> when an issue arises. They have consistently strived for the <strong>most innovative and user friendly solutions to optimize our business</strong>.",
          img: {
            src: "caroline.jpg",
            alt: "Caroline",
          },
          personInfo: "Caroline W",
          link: {
            text: "",
            url: "https://www.trustingconnections.com/",
          },
        },
        {
          text: "When I first spoke with Enginehire I thought the price was a little steep and almost did not move forward. Ever since then <strong>the price is worth every penny.</strong> If I ever need anything updated, <strong>they respond almost immediately</strong> with a solution. They are continuously working to keep the system updated and <strong>always adding new features</strong>!",
          img: {
            src: "SarahM.png",
            alt: "Sarah Meadors",
          },
          personInfo: "Sarah M",
          link: {
            text: "",
            url: "https://nanniescoasttocoast.com/",
          },
        },
        // {
        //   text: "<strong>BEST software you will find in the market for NANNY AGENCIES! The automation of the system saves so much time</strong> and the way <strong>you just need to use one software instead of having 10 software for different things.</strong> Also, they are very accommodating to your needs.",
        //   img: {
        //     src: "Alejandra.png",
        //     alt: "Alejandra La Lune",
        //   },
        //   personInfo: "Alejandra D - Owner of",
        //   link: {
        //     text: "La Lune Sitters",
        //     url: "https://www.lalunesitters.com/",
        //   },
        // },
        {
          text: "The Enginehire team was absolutely <strong>wonderful to work with; professional, dedicated, and supportive</strong>. I cannot recommend Enginehire enough if you're looking for a way to <strong>streamline your processes</strong> and work with a patient and understanding team.",
          img: {
            src: "deniz.jpg",
            alt: "Deniz",
          },
          personInfo: "Deniz H",
          link: {
            text: "",
            url: "https://www.trustednannymatch.com/",
          },
        },
        {
          text: "The Enginehire Team have been excellent to work with and provide <strong>phenomenal customer service</strong>. Their <strong>knowledge of the industry and individual customization is unparalleled</strong> and their platform has revolutionized the way that my team does business.",
          img: {
            src: "lydia.jpg",
            alt: "Lydia",
          },
          personInfo: "Lydia B",
          link: {
            text: "",
            url: "https://www.chicagocollegiatenannies.com/",
          },
        },
      ],
      listAgencies: [
        // {
        //   url: "https://trustingconnections.com/",
        //   logo: "trusting_connections-emblem_vector-gold.svg",
        //   alt: "Trusting Connections",
        // },
        {
          url: "https://www.tinytreasuresnyc.com/",
          logo: "tiny treasureshi res.jpg",
          alt: "Tiny Treasures",
        },
        {
          url: "https://www.406nannies.com/",
          logo: "406Nannies-FullColor-2.png",
          alt: "406 Nannies",
        },
        {
          url: "https://www.ateasefamilysolutions.com/",
          logo: "at-ease_new-logo_300ppi-PNG.png",
          alt: "At Ease Family Solutions",
        },
        {
          url: "https://www.thewellingtonagency.com/",
          logo: "the-wellington-agency-logo.png",
          alt: "The Wellington Agency",
        },
        // {
        //   url: "https://www.thenannycompany.ca/",
        //   logo: "NAN_logomark_RGB_Evergreen.png",
        //   alt: "The Nanny Company",
        // },
        {
          url: "https://www.grapevineplacementagency.com/",
          logo: "Grapevine Nannies and Domestics full color logo.png",
          alt: "Grapevine Placement Agency",
        },
        {
          url: "https://www.lalunesitters.com/",
          logo: "LogoLaLuneSittersvector_whitefill.svg",
          alt: "La Lune Sitters",
        },
        {
          url: "https://www.lovingcarehomeservices.com/",
          logo: "LovingCareColor.png",
          alt: "Loving Care Home Services",
        },
        // {
        //   url: "http://littleonesnannyagency.com/",
        //   logo: "littleones.jpg",
        //   alt: "Little Ones Nanny Agency",
        // },
        {
          url: "https://apex-social.org/us",
          logo: "logo_apex_basic_V2_600px.jpg",
          alt: "Apex Social",
        },
        {
          url: "https://washburnagency.com/",
          logo: "washburn-share-logo (1).jpg",
          alt: "The Washburn Agency",
        },
        {
          url: "http://www.oliveyounanny.com/",
          logo: "OYN-logo-2016_copy_317757b7-57e2-47bc-8bf0-66ccdab347ee.jpg",
          alt: "Olive You Nanny",
        },
        // {
        //   url: "https://nanniesofthewoodlands.com/",
        //   logo: "nanniesofthewoodlands_busdir.jpg",
        //   alt: "Nannies of the Woodlands",
        // },
        {
          url: "https://www.nannyportugal.com/",
          logo: "Nanny Portugal Agency Logo Blue.png",
          alt: "Nanny Portugal",
        },
        {
          url: "https://www.manhattannannies.com/",
          logo: "manhattan_nannies.jpg",
          alt: "Manhattan Nannies",
        },
        {
          url: "https://www.nashvillenannyagency.com/",
          logo: "NNA.jpg",
          alt: "Nashville Nanny Agency",
        },
        {
          url: "https://www.trustednannymatch.com/",
          logo: "TNM-Monogram-DarkNavy.svg",
          alt: "Trusted Nanny Match",
        },
        {
          url: "https://www.windsorhousenannies.com/",
          logo: "whn.png",
          alt: "Windsor House Nannies",
        },
        {
          url: "https://pinknannies.com/",
          logo: "PinkNannies-Circle.svg",
          alt: "Pink Nannies",
        },
        {
          url: "https://chicagocollegiatenannies.com/",
          logo: "collegiate_nannies.svg",
          alt: "Collegiate Nannies",
        },
        {
          url: "https://mansfielddomestics.com/",
          logo: "Main Logo Green and Yellow.png",
          alt: "Mansfield Domestics",
        },
        {
          url: "http://minannyauthority.com/",
          logo: "logo-minanny.png",
          alt: "Michigan Nanny Authority",
        },
        {
          url: "https://thenannyhub.com/",
          logo: "thenannyhub.png",
          alt: "The Nanny Hub",
        },
      ],
      listFeatures: [
        {
          icon: "userprofiles3.1.svg",
          title: "Candidate Profiles",
          text: "Modern digital showcases - no more writing and reformatting resumes",
        },
        {
          icon: "beautifulwebsite.svg",
          title: "Client Dashboards",
          text: "Empower your clients, make it easy for them to do what you need them to",
        },
        {
          icon: "briefcase.svg",
          title: "Beautiful Job Postings",
          text: "Seamlessly collect applications and attract the best candidates",
        },
        {
          icon: "phonetracking.svg",
          title: "Shift Management",
          text: "Manage schedules and fill short term placements in seconds",
        },
        {
          icon: "SMS.svg",
          title: "Auto Email+SMS",
          text: "Spend time actually talking to people - no more rewriting the same thing",
        },
        {
          icon: "calendar.svg",
          title: "Scheduling",
          text: "Integrated scheduling, no more back and forth “when are you free?” emails",
        },
        {
          icon: "creditcards.svg",
          title: "Payments",
          text: "Built in payment processing - no more chasing clients to pay invoices",
        },
        {
          icon: "blogwriting.svg",
          title: "Notes",
          text: "Interviews, consultations, reference checks - all your notes, all in one place",
        },
        {
          icon: "document.svg",
          title: "Documents",
          text: "Built in documents and e-signatures - no need for PDFs or DocuSign",
        },
        {
          icon: "analytics.svg",
          title: "Analytics",
          text: "Understand what’s working, what’s not, and how to grow your business further",
        },
      ],
    };
  },
  methods: {
    incrementLogoCount() {
      if (this.logoCount == this.listAgencies.length) {
        this.logoCount = 1;
      } else {
        this.logoCount += 1;
      }
    },
  },
};
</script>

<style>
.landing {
  /* height: 100vh; */
  /* background-color: var(--skyblue); */
  background-color: var(--coredarkcolor);
  /* background-color: #fcbf67; */
  width: 100%;

  /* height: 75vh; */
  /* height: 70vh; */
  min-height: 550px;
  /* padding-left: 5%; */
  /* padding-right: 5%; */

  background-color: white;
  background: url("../assets/img/home/landing/VA shaded1.png") left center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: left top; */
}

.mobile-landing {
  /* height: 100vh; */
  background-color: var(--shopify);
  background-color: #fcbf67;
  width: 100%;

  /* height: 75vh; */
  /* height: 70vh;  */
  /* min-height: 550px; */
  padding-left: 5%;
  padding-right: 5%;

  background-color: white;
  /* background-image: url('https://thewallpaper.co//wp-content/uploads/2016/10preview/goku-universal-hero-backgrounds-photo-hd-wallpapers-4k-amazing-desktop-wallpapers-mac-desktop-images-widescreen-1080p-digital-photos-1920x1080.jpg'); */
  /* background-image: url('../assets/img/AdobeStock_272829109_Preview2.png'); */
  /* background-image: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg'); */
  /* background: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/AdobeStock_95578556_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/employer/AdobeStock_95578556_crop1_resize1.jpeg') left center; */
  background: url("../assets/img/home/landing/VA shaded1.png") center center;
  /* background-size: auto 100%; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: left top; */
}

.customer-logo-container {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 7px;
  padding-bottom: 38px;
}
.customer-logo {
  height: 70px;
  /* max-width: 100px; */
}

.association-logo-container {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 7px;
  padding-bottom: 38px;
}
.association-logo {
  height: 150px;
  /* max-width: 100px; */
}

.feature-card {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.card {
  padding-top: 30px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  /* box-shadow: 0 .25rem 0.5rem rgba(0,0,0,.15); */
  text-align: center;
  margin-top: 25px;
  /* margin-left: auto; */
  /* margin-right: auto; */

  border: none;
}
.card-body {
  padding: 0.1rem;
}
.feature-card img {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px;
}
.card img {
  /* text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px; */
}
.card-img-top {
  /* text-align: center; */
  display: block;
  margin-left: 0 !important;
  margin-right: auto !important;
  text-align: left;
  float: left;
  height: 70px;
  margin-bottom: 10px;
}
.feature-img {
  height: 70px;
  display: block;
  margin-right: auto;
  margin-bottom: 10px;
}
.feature-card-title {
  margin-top: 15px;
}
.card-title {
  line-height: 1.3;
  text-align: left;
}
.card-text {
  text-align: left;
}

.testimonial-card {
  /* background-color: #eaf4fe; */
}
.testimonial-card img {
  /* height: 150px;
  width: 150px;
  border-radius: 50%; */
}

.customer-image {
  border-radius: 50%;
  width: 150px;
}

.visit-platform-button {
  margin-top: 33px;
  margin-bottom: 12px;
}

.logo-enter {
  opacity: 0;
}
.logo-enter-active {
  transition: opacity 1s;
}
.logo-leave {
}
.logo-leave-active {
  transition: opacity 1s;
  opacity: 0;
}

/* ------------------- SMALL -------------------- */
@media (max-width: 768px) {
  .card {
    /* margin-top: 20px; */
    margin-top: 2px;
  }
  .card-deck .card {
    margin-bottom: 2px;
  }
}

.card-image-container {
  text-align: center;
  margin: 1rem 0;
}

.card-image {
  border-radius: 50%;
  text-align: left;
}

.medium-carousel {
  display: none;
}
.big-carousel {
  display: inherit;
}

.small-carousel {
  display: inherit;
  margin: 0 40px;
}
.tiny-carousel {
  display: none;
}

.features-summary-section {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 120px;
}

.feature-container {
  flex-basis: 20%;
  padding-left: 30px;
  padding-right: 30px;
}

@media (max-width: 1280px) {
  .medium-carousel {
    display: inherit;
  }
  .big-carousel {
    display: none;
  }
  .feature-container {
    flex-basis: 25%;
  }
}

@media (max-width: 960px) {
  .feature-container {
    flex-basis: 33.33%;
  }
}

@media (max-width: 768px) {
  .features-summary-section {
    margin-bottom: 100px;
  }
  .feature-container {
    flex-basis: 50%;
  }
}

@media (max-width: 575px) {
  .feature-container {
    flex-basis: 100%;
  }
}

@media (max-width: 460px) {
  .small-carousel {
    display: none;
  }
  .tiny-carousel {
    display: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeVA.vue